import { Component, OnInit, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BadWordsApiService } from '../../_services/bad-words/bad-words-api.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { $DBManagerService } from 'src/app/_helpers/DB/DBManager.service';
import { $ModalManagerService } from 'src/app/_helpers/Modals/ModalManager.service';


@Component({
  selector: 'app-bad-words-import',
  templateUrl: './bad-words-import.component.html',
  styleUrls: ['./bad-words-import.component.css']
})
export class BadWordsImportComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Restricted_Words', 'Delete'];

  word: any;
  submitted: boolean;
  radioSelection: String;
  radioSelectionSingle: boolean;
  radioSelectionMultiple: boolean;
  uploadFile: any;
  Entity_Ref_No: any;
  Entity_Name: any;
  constructor(
    private fb: FormBuilder,
    private bw: BadWordsApiService,
    private cdr: ChangeDetectorRef,
    private db:$DBManagerService,
    private $modal: $ModalManagerService,
  ) { }
  badWordForm: FormGroup;
  restrictedWords: any[] = [];

  get f() { return this.badWordForm.controls; }

  ngOnInit() {
    this.badWordForm = this.fb.group({
      badWord: ['', Validators.required],
      uploadFile: []

    })
    this.getRestrictedWords();
  }

  //following function will check for the radio button selection
  onChangeSelOpt(event) {
    console.log("on change radio button called")
    console.log(event.value);
    this.radioSelection = event.value;
    console.log("selected radion button",this.radioSelection)
    if (event.value === 'Single') {
      this.radioSelectionSingle = true;
      this.radioSelectionMultiple = false;
    }

    else {
      this.radioSelectionMultiple = true;
      this.radioSelectionSingle = false;
    }
  }

  // on change file upload
  onChangeFileUpload(event) {
    console.log("inside onchange func event :", event);
    this.uploadFile = event.target.files;
    console.log("this.uploadFile  :", this.uploadFile);
  }

  // on submitting the form

  onSubmit() {
    console.log(this.radioSelection);
    this.submitted = true;
   
    if (this.radioSelection === 'Single') {
      this.word = this.badWordForm.get('badWord').value;
      
      var data = {
        "Restricted_Words": this.word
      }
      this.bw.addBadWords(data).subscribe(r => {
        console.log("i got response",r);
        // checking if the word is already there in DataBase
        if(r.Error==='This word is already present in Db')
        {
          this.$modal.errorModal({
            title: 'Error',
            msg: 'This word already exists'
          });
        }
        this.getRestrictedWords();
      })
    }
    else
    {
      const importForm: FormData = new FormData();
    
    console.log("file upload vvalue",this.badWordForm.get('uploadFile').value);
    const file1: any = document.getElementById('uploadFile');
       importForm.append('file1', file1.files[0]);
      this.bw.uploadRestrictedFile(importForm).subscribe(
        r=>{
          console.log("file upload called");
          console.log("response",r)
          this.getRestrictedWords();
        }
      )
    
    }

    // resetting the form data
    this.badWordForm.reset();
  }

  getRestrictedWords() {
    // getting the data from database
    this.bw.getRestrictedWords()
      .subscribe(r => {
        this.restrictedWords = r;
        console.log("Inside Get Restriced words ", r);
        this.onChangeDataSource(this.restrictedWords);
      })
  }

  deleteRestrictedWord(resWord) {
    console.log("word before leave: ", resWord);
    this.bw.deleteRestrictedWords(resWord)
      .subscribe(res => {
        console.log("Deleted Word: ", res);
        // this.getRestrictedWords();   
        this.restrictedWords = this.restrictedWords.filter(res => {
          return res.Restricted_Words !== resWord
        });
        this.onChangeDataSource(this.restrictedWords);
      })
  }

  onChangeDataSource(value) {
    this.dataSource = new MatTableDataSource(value);
    this.cdr.detectChanges();
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

  }
}
